<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col">
       <h1>Travel</h1>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      travel: (state) => state.travel.travel
    })
  },
  async created() {
    await this.loadTravelData();
  },
  methods: {
    ...mapActions('travel', ['getTravelDataAction']),
    async loadTravelData() {
      await this.getTravelDataAction();
    }
  },
};
</script>
